/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modern_Sans_InterInputs */

const en_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern Sans (Inter)`)
};

const es_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern Sans (Inter)`)
};

const fr_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderne Sans-serif (Inter)`)
};

const de_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern Sans (Inter)`)
};

const ja_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モダンサンセリフ (Inter)`)
};

const zh_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`现代无衬线 (Inter)`)
};

const ar_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حديث بلا حواف (Inter)`)
};

const id_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern Sans (Inter)`)
};

const it_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern Sans (Inter)`)
};

const ru_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Современный (Inter)`)
};

const pt_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern Sans (Inter)`)
};

const ko_modern_sans_inter = /** @type {(inputs: Modern_Sans_InterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모던 산세리프 (Inter)`)
};

/**
* | output |
* | --- |
* | "Modern Sans (Inter)" |
*
* @param {Modern_Sans_InterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const modern_sans_inter = /** @type {((inputs?: Modern_Sans_InterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modern_Sans_InterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_modern_sans_inter(inputs)
	if (locale === "es") return es_modern_sans_inter(inputs)
	if (locale === "fr") return fr_modern_sans_inter(inputs)
	if (locale === "de") return de_modern_sans_inter(inputs)
	if (locale === "ja") return ja_modern_sans_inter(inputs)
	if (locale === "zh") return zh_modern_sans_inter(inputs)
	if (locale === "ar") return ar_modern_sans_inter(inputs)
	if (locale === "id") return id_modern_sans_inter(inputs)
	if (locale === "it") return it_modern_sans_inter(inputs)
	if (locale === "ru") return ru_modern_sans_inter(inputs)
	if (locale === "pt") return pt_modern_sans_inter(inputs)
	return ko_modern_sans_inter(inputs)
});